import {createBrowserHistory, History} from "history";

class NavigationService {
    private static _instance: NavigationService

    history: History

    constructor() {
        this.history = createBrowserHistory()
    }

    static get instance() {
        if (!NavigationService._instance) {
            NavigationService._instance = new NavigationService()
        }
        return NavigationService._instance
    }

    navigateTo(route: string) {
        this.history.push(route)
    }

    navigateHome() {
        this.navigateTo('/')
    }

    navigateReviewPending() {
        this.navigateTo('/review/pending_mode')
    }

    navigateReviewDuplicates() {
        this.navigateTo('/review/duplicates_mode')
    }

    navigateUploadPending() {
        this.navigateTo('/upload_pending_films')
    }
}

export default NavigationService
